export default __webpack_public_path__ + "static/media/2.7510aa18.jpg";